// --------------------------------------------------------------
// Created On: 2025-03-12
// Author: Hannah Vaughan
//
// Last Modified: 2025-11-06
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./OrderHistoryForm.module.scss";

// Form to search the sales order history by PO #, sales order #, grand total, status, and order date.
export default function OrderHistoryForm(props: Props): Component {
  return (
    <div data-test="order-history-table-container" className={`${styles.body} table-responsive mb-0 pb-0`}>
      <div className={styles.header}>
        <div className="row pt-3 pb-3 px-2">
          {/* Title. */}
          <div className="col-6">
            <span data-test="order-history-table-title">Order History ({props.rowCount})</span>
          </div>
        </div>
        <div className="row mb-2 mx-auto">
          <div className="col-5 col-sm-6 col-lg-7">
            <div className="input-group">
              <input
                data-test="order-history-table-filter-input"
                type="search"
                className="form-control rounded"
                placeholder="Search all orders..."
                value={props.filter}
                onChange={(e) => props.onChangeFilter(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4 col-sm-4 col-md-3">
            <select
              data-test="order-history-date-filter-dropdown"
              className="form-select form-control"
              value={props.dateFilter}
              onChange={(e) => props.onChangeDateFilter(parseInt(e.target.value))}
            >
              <option value={30}>30 days</option>
              <option value={90}>3 months</option>
              <option value={365}>1 year</option>
              <option value={0}>All time</option>
            </select>
          </div>
          <div className="col-auto">
            <div className="d-flex align-items-center">
              <button
                data-test="order-history-search-orders-button"
                className={`${styles.searchButton} btn mb-3`}
                type="button"
                onClick={() => props.onPerformSearch()}
              >
                <div className="d-none d-md-inline">Search Orders</div>
                <i className="fa fa-fw fa-search d-inline d-md-none" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

interface Props {
  rowCount: number;
  filter: string;
  dateFilter: number;
  onChangeFilter: (filter: string) => void;
  onChangeDateFilter: (dateFilter: number) => void;
  onPerformSearch: () => void;
}
